import ICompanyInfo from '@/types/ICompanyInfo';

export default class CompanyFactory {
  static toCompanyInfo(data: any): ICompanyInfo {
    return {
      address: {
        addressId: data.address.addressId,
        city: data.address.city,
        postalCode: data.address.postalCode,
        address: data.address.address,
        countryId: data.address.countryId,
        companyName: data.name
      },
      id: data.id,
      params: {
        accessKey: data.params.accessKey,
        authToken: data.params.authToken,
        clientSecret: data.params.clientSecret,
        developerId: data.params.developerId,
        reportDate: data.params.sendDate,
        sellerId: data.params.sellerId
      }
    }
  }
}
